export const reviews = [
  {
    id: 1,
    name: "Ana & Marko",
    tripKey: "barcelona",
    rating: 5,
    text_hr:
      "Savršeno organizirano putovanje, odličan vodič i puno slobodnog vremena za vlastito istraživanje.",
    text_en:
      "Perfectly organized trip, great guide and plenty of free time to explore.",
    text_de:
      "Perfekt organisierte Reise, toller Guide und viel Freizeit zum Entdecken.",
    text_es:
      "Viaje perfectamente organizado, excelente guía y mucho tiempo libre para explorar.",
  },
  {
    id: 2,
    name: "Petra",
    tripKey: "mexico",
    rating: 5,
    text_hr:
      "Meksiko je nadmašio sva očekivanja, a podrška agencije je stvarno bila 24/7.",
    text_en:
      "Mexico exceeded all expectations, and the agency support was truly 24/7.",
    text_de:
      "Mexiko hat alle Erwartungen übertroffen, der Agentursupport war wirklich 24/7.",
    text_es:
      "México superó todas las expectativas y el soporte de la agencia fue 24/7.",
  },
  {
    id: 3,
    name: "Lena",
    tripKey: "tuscany",
    rating: 4.8,
    text_hr:
      "Toskana je bila san – vinarije, sela, more… sve je bilo lagano i opušteno.",
    text_en:
      "Tuscany was a dream – wineries, villages, the sea… everything was relaxed.",
    text_de:
      "Die Toskana war ein Traum – Weingüter, Dörfer, Meer… alles sehr entspannt.",
    text_es:
      "La Toscana fue un sueño: bodegas, pueblos, mar… todo muy relajado.",
  },
  {
    id: 4,
    name: "Ivana i Tomislav",
    tripKey: "valladolid-1tjedan-lipanj",
    rating: 5,
    text_hr:
      "Valladolid nas je oduševio – Lina zna svaki kutak, a radionica paelle i posjet vinarijama bili su vrhunac putovanja. Sve besprijekorno organizirano.",
    text_en:
      "Valladolid blew us away – Lina knows every corner, and the paella workshop and winery visit were the highlights. Flawlessly organized.",
    text_de:
      "Valladolid hat uns begeistert – Lina kennt jede Ecke, Paella-Workshop und Weingutbesuch waren die Höhepunkte. Makellos organisiert.",
    text_es:
      "Valladolid nos encantó – Lina conoce cada rincón, el taller de paella y la visita a la bodega fueron lo mejor. Todo impecable.",
  },
  {
    id: 5,
    name: "Davor",
    tripKey: "alicante",
    rating: 5,
    text_hr:
      "Alicante u proljeće – savršen izbor. Mali broj ljudi u grupi, autentični doživljaji, nikad nisam osjetio da sam 'turist'. Preporučujem svima.",
    text_en:
      "Alicante in spring – perfect choice. Small group, authentic experiences, never felt like a 'tourist'. Recommend to everyone.",
    text_de:
      "Alicante im Frühling – perfekte Wahl. Kleine Gruppe, authentische Erlebnisse, habe mich nie wie ein 'Tourist' gefühlt. Sehr empfehlenswert.",
    text_es:
      "Alicante en primavera – elección perfecta. Grupo pequeño, experiencias auténticas, nunca me sentí 'turista'. Lo recomiendo.",
  },
  {
    id: 6,
    name: "Maja",
    tripKey: "cuba",
    rating: 5,
    text_hr:
      "Kuba s TraveLinom bila je iskustvo života. Nije bilo tipičnog all-inclusivea – upoznali smo ljude, glazbu i pravi ritam otoka. Hvala!",
    text_en:
      "Cuba with TraveLina was the experience of a lifetime. No typical all-inclusive – we met the people, the music and the real rhythm of the island. Thank you!",
    text_de:
      "Kuba mit TraveLina war ein Erlebnis fürs Leben. Kein typisches All-inclusive – wir haben die Menschen, die Musik und den echten Rhythmus der Insel kennengelernt. Danke!",
    text_es:
      "Cuba con TraveLina fue la experiencia de una vida. Nada de todo incluido típico – conocimos a la gente, la música y el ritmo real de la isla. ¡Gracias!",
  },
  {
    id: 7,
    name: "Katarina & Bruno",
    tripKey: "madrid",
    rating: 5,
    text_hr:
      "Madrid, muzeji, tapas i noćni život – sve u jednom. Organizacija na najvišoj razini, a Lina nam je pomogla i s jezikom. Vratit ćemo se.",
    text_en:
      "Madrid, museums, tapas and nightlife – all in one. Top-notch organization, and Lina helped us with the language too. We'll be back.",
    text_de:
      "Madrid, Museen, Tapas und Nachtleben – alles in einem. Organisation auf höchstem Niveau, und Lina hat uns auch mit der Sprache geholfen. Wir kommen wieder.",
    text_es:
      "Madrid, museos, tapas y vida nocturna – todo en uno. Organización de primera, y Lina nos ayudó también con el idioma. Volveremos.",
  },
  {
    id: 8,
    name: "Nikola",
    tripKey: "valladolid-1tjedan",
    rating: 4.9,
    text_hr:
      "Učio sam španjolski u Valladolidu kroz putovanje – najbolja odluka. Grupa mala, atmosfera odlična, sve je teklo prirodno. TraveLina zna što radi.",
    text_en:
      "I learned Spanish in Valladolid through the trip – best decision. Small group, great atmosphere, everything felt natural. TraveLina knows what they're doing.",
    text_de:
      "Ich habe Spanisch in Valladolid durch die Reise gelernt – beste Entscheidung. Kleine Gruppe, tolle Atmosphäre, alles wirkte natürlich. TraveLina weiß, was sie tut.",
    text_es:
      "Aprendí español en Valladolid con el viaje – la mejor decisión. Grupo pequeño, ambiente genial, todo fluyó natural. TraveLina sabe lo que hace.",
  },
  {
    id: 9,
    name: "Sonja",
    tripKey: "valencia",
    rating: 5,
    text_hr:
      "Valencia – grad sunca i umjetnosti. Program je bio ravnoteža između vodiča i slobode. Plaže, paella, Ciutat de les Arts… sve na mjestu.",
    text_en:
      "Valencia – city of sun and art. The programme balanced guided time and freedom. Beaches, paella, Ciutat de les Arts… everything in place.",
    text_de:
      "Valencia – Stadt der Sonne und Kunst. Das Programm war die richtige Mischung aus Führung und Freiheit. Strände, Paella, Ciutat de les Arts… alles perfekt.",
    text_es:
      "Valencia – ciudad de sol y arte. El programa equilibraba guía y libertad. Playas, paella, Ciutat de les Arts… todo en su sitio.",
  },
  {
    id: 10,
    name: "Martina i Filip",
    tripKey: "barcelona",
    rating: 5,
    text_hr:
      "Prvo putovanje s TraveLinom – sigurno ne zadnje. Barcelona nam je bila bliska, a grupa je postala kao obitelj. Profesionalno i toplo.",
    text_en:
      "First trip with TraveLina – definitely not the last. Barcelona felt close to us, and the group became like family. Professional and warm.",
    text_de:
      "Erste Reise mit TraveLina – bestimmt nicht die letzte. Barcelona fühlte sich nah an, die Gruppe wurde zur Familie. Professionell und herzlich.",
    text_es:
      "Primer viaje con TraveLina – seguro que no el último. Barcelona nos quedó cerca y el grupo se volvió como familia. Profesional y cercano.",
  },
  {
    id: 11,
    name: "Andreja",
    tripKey: "galicia",
    rating: 5,
    text_hr:
      "Galicija je ostavila trag – obala, hrana, ljudi. Nisam očekivala toliko osobnu pažnju od agencije. Svaka preporuka za TraveLinu.",
    text_en:
      "Galicia left a mark – coast, food, people. I didn't expect such personal attention from the agency. Full recommendation for TraveLina.",
    text_de:
      "Galicien hat Spuren hinterlassen – Küste, Essen, Menschen. So viel persönliche Betreuung hatte ich nicht erwartet. Volle Empfehlung für TraveLina.",
    text_es:
      "Galicia dejó huella – costa, comida, gente. No esperaba tanta atención personal de la agencia. Recomiendo totalmente TraveLina.",
  },
  {
    id: 12,
    name: "Marko",
    tripKey: "mexico",
    rating: 4.9,
    text_hr:
      "Meksiko je bio avantura kakvu sam želio – cenote, džungla, plaže, povijest. Organizacija bez zamjerke, a Lina je uvijek bila dostupna za savjet.",
    text_en:
      "Mexico was the adventure I wanted – cenotes, jungle, beaches, history. Flawless organization, and Lina was always there for advice.",
    text_de:
      "Mexiko war das Abenteuer, das ich wollte – Cenoten, Dschungel, Strände, Geschichte. Makellose Organisation, Lina war immer für Tipps da.",
    text_es:
      "México fue la aventura que quería – cenotes, selva, playas, historia. Organización impecable y Lina siempre disponible para consejos.",
  },
  {
    id: 13,
    name: "Tihana",
    tripKey: "alicante",
    rating: 5,
    text_hr:
      "Proljetni bijeg na Costa Blancu – točno ono što mi je trebalo. Paella radionica, dvorac, more… sve u nekoliko dana. TraveLina isporučuje.",
    text_en:
      "Spring escape to the Costa Blanca – exactly what I needed. Paella workshop, castle, sea… everything in a few days. TraveLina delivers.",
    text_de:
      "Frühlingsflucht an die Costa Blanca – genau das, was ich brauchte. Paella-Workshop, Burg, Meer… alles in wenigen Tagen. TraveLina liefert.",
    text_es:
      "Escapada de primavera a la Costa Blanca – exactamente lo que necesitaba. Taller de paella, castillo, mar… todo en pocos días. TraveLina cumple.",
  },
];
